import CenterMessage from "./CenterMessage";

export default function NoInternet() {
  return (
    <CenterMessage message="No internet connection. Please check your network settings." />
  );
}
